import { Component, ElementRef, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { DialogService } from './dialog.service';

@Component({
    selector: 'app-dialog',
    templateUrl: './dialog.component.html',
    styleUrls: ['./dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DialogComponent {
  @Input() wideMode = false;
  @Input() disableESC = false;
  // Optional colored top border on the dialog (e.g. avatar/branch color), matching the dashboard cards.
  @Input() topColor = '';
  @Output() closeEvent = new EventEmitter<boolean>();
  shown = false;

  constructor(private dialogService: DialogService, private elementRef: ElementRef) {}

  show(): void {
    const htmlTag = document.querySelector('html');
    htmlTag?.classList.add('dialogForm-locked');
    this.shown = true;
    this.dialogService.openDialog(this);
    this.elementRef.nativeElement.style.zIndex = 9998 + this.dialogService.openedDialogs.length;
  }

  hide(): void {
    if(this.shown){
        this.dialogService.closeDialog(this);
        this.shown = false;
        this.elementRef.nativeElement.style.zIndex = '';
        this.closeEvent.emit(true);
    }
  }

}
